import {
  Flex,
  Box,
  Icon,
  Image,
  Link,
  useBreakpointValue,
} from '@chakra-ui/react';
import LoginImg from '../../img/login.jpg';
import { TradeMarkFooter } from '../trade-mark-footer';
import { KulaTextLogo } from '@/assets/icons/colored';
import { KText } from '@/ui-library/components';
import { Link as ReactLink } from 'react-router-dom';

export const Wrapper = ({ children, isSignUp = false }) => {
  const showImage = useBreakpointValue({ base: false, md: false, lg: true });
  return (
    <Flex
      height="100%"
      minH="100vh"
      overflowY="hidden"
      flexDir={{ base: 'column', lg: 'row' }}
    >
      <Box
        width={{ base: '100%', md: '100%', lg: '40%' }}
        pos="relative"
        p={{ base: '24px', md: '36px' }}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100vh"
        overflowY={{ base: 'auto', md: 'auto', lg: 'visible' }}
        alignItems={{ base: 'center', md: 'center', lg: 'flex-start' }}
      >
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          justifyContent={{ base: 'center', lg: 'space-between' }}
          alignItems="center"
          mb="12px"
          w="100%"
          gap={{ base: 2, lg: 0 }}
        >
          <Icon as={KulaTextLogo} width="90px" height="30px" />
          {isSignUp && (
            <KText
              fontSize="14px"
              color="primary-900"
              textAlign={{ base: 'center', lg: 'right' }}
              mt={{ base: 1, lg: 0 }}
              whiteSpace="nowrap"
            >
              Already a member?{' '}
              <Link
                as={ReactLink}
                to="/login"
                fontWeight="bold"
                color="primary-500"
              >
                Login now
              </Link>
            </KText>
          )}
        </Flex>
        <Flex
          flex="1"
          justifyContent="center"
          alignItems="center"
          flexDir="column"
          overflowY="visible"
          w="100%"
          px={{ base: 2, md: 4, lg: 0 }}
          py={{ base: 4, md: 6, lg: 0 }}
        >
          <Box
            w={{ base: '100%', sm: '90%', md: '80%', lg: '100%' }}
            maxW={{ base: '400px', md: '500px', lg: 'unset' }}
          >
            {children}
          </Box>
        </Flex>
        <Flex
          justifyContent="center"
          alignItems="center"
          w="100%"
          mt={{ base: 4, md: 6 }}
          pb={{ base: 2, md: 4 }}
          flexShrink={0}
        >
          <TradeMarkFooter isSignUp={isSignUp} />
        </Flex>
      </Box>
      {showImage && (
        <Box
          flex="1"
          bg="#EDF6FF"
          height="100%"
          display={{ base: 'none', md: 'block' }}
        >
          <Image
            src={LoginImg}
            objectFit="cover"
            width="100%"
            height="100%"
            objectPosition="top"
          />
        </Box>
      )}
    </Flex>
  );
};
